const findItem = (data, path)=>{
    for (const item of data) {
        if (item.path === path) {
          return item;
        }
        if (item.children) {
          const result = findItem(item.children, path);
          if (result) {
            return result;
          }
        }
      }
      return null;
}
export default findItem